import React, { useState } from 'react';

import Button from 'components/shared/Button';
import Input from 'components/shared/Input';
import Modal from 'components/shared/Modal';

import { useAppDispatch, useAppSelector } from 'utils/hooks';

import savedArrangements from 'domains/saved_arrangements';

import { selectCartPhotos } from 'selectors/cart_photos';

import type { SavedArrangement } from 'domains/saved_arrangements';

type EditArrangementModalProps = {
  onClose: () => void;
  arrangement?: SavedArrangement;
};

function EditArrangementModal({ onClose, arrangement }: EditArrangementModalProps) {
  const dispatch = useAppDispatch();
  const cartPhotos = useAppSelector(selectCartPhotos);

  // Default to true only if we have:
  // Photos in nodes, an existing arrangement loaded, and that arrangement has existing crops
  const [includePhotos, setIncludePhotos] = useState(
    cartPhotos.length > 0 && !!arrangement && arrangement.crops.length > 0
  );

  const [name, setName] = useState(() => {
    return arrangement ? arrangement.name : 'My Custom Arrangement';
  });

  function handleSaveArrangement(overwrite?: boolean) {
    if (overwrite && arrangement?.id) {
      dispatch(
        savedArrangements.actions.update.pending({ name, includePhotos, id: arrangement.id })
      );
    } else {
      dispatch(savedArrangements.actions.create.pending({ name, includePhotos }));
    }

    onClose();
  }

  const primaryFooterGroup = (
    <React.Fragment>
      {arrangement && (
        <Button type="outline" onClick={() => handleSaveArrangement(true)}>
          Overwrite Current Arrangement
        </Button>
      )}
      <Button type="confirm" onClick={() => handleSaveArrangement()}>
        Save{arrangement ? ' as New' : ''}
      </Button>
      <Button type="cancel" onClick={onClose}>
        Cancel
      </Button>
    </React.Fragment>
  );

  return (
    <Modal
      title="Save Arrangement"
      labelledBy="save-arrangement-modal"
      modalClass={['save-arrangement-modal']}
      lastFocusedElementId="save-custom-arrangement-button"
      onClose={onClose}
      primaryFooterGroup={primaryFooterGroup}
    >
      <Input
        id="save-arrangement-name"
        label="Name this arrangement"
        onChange={(value: string) => setName(value)}
        value={name}
      />
      <React.Fragment>
        {cartPhotos.length > 0 && (
          <label className="include-photos-input">
            <input
              type="checkbox"
              id="include-crops-checkbox"
              onChange={() => setIncludePhotos(!includePhotos)}
              checked={includePhotos}
            />
            Include Selected Photos in this Arrangement
          </label>
        )}
      </React.Fragment>
    </Modal>
  );
}

export default EditArrangementModal;
